/**
 * @generated SignedSource<<61a0f33caf2124e945e989cf2ef61d82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgBillingContainer_organization$data = {
  readonly monthlyMetrics: ReadonlyArray<{
    readonly name: string;
    readonly value: number | null;
  } | null>;
  readonly " $fragmentType": "OrgBillingContainer_organization";
};
export type OrgBillingContainer_organization$key = {
  readonly " $data"?: OrgBillingContainer_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgBillingContainer_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgBillingContainer_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportMetricResult",
      "kind": "LinkedField",
      "name": "monthlyMetrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "b829a2921e7465199fdf601a5f9357cd";

export default node;
